// Polyfills
import 'core-js/es/array/flat';
import 'core-js/es/array/flat-map';
import 'core-js/es/array/includes';
import 'core-js/es/object';
import 'core-js/es/symbol';
import './core/setup/setupYup';
import './core/setup/setupAuth';
import './core/setup/setupImmer';
// Locale
import './core/dates/initDayjs';
import './core/setup/setupIntl';
// Styles
import 'antd/dist/reset.css';
import { apiClient, joinPath } from '@framework/api-client';
import { refreshTokenInterceptor } from '@framework/auth';
import { initCommonWebWidgetRepository } from '@framework/common-web';
import { EngineThemeProvider } from '@framework/engine';
import { I18nConfigProvider } from '@framework/i18n';
import {
  AntThemeProvider,
  BreadcrumbProvider,
  ButtonTooltipsGlobalStyle,
  LayoutGlobalStyle,
  MessageGlobalConfiguration,
} from '@framework/ui';
import {
  FontGlobalStyle,
  theme,
  themeComponentTokens,
  ThemeGlobalStyle,
  ThemeRootProvider,
  themeTokens,
} from '#theme';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { appConfig } from './core/appConfig';
import { queryClient } from './core/network/queryClient';
import { store } from './core/store/store';
import { Routes } from './routes/Routes';

// Configuro il client delle API. Inserire in file dedicato.
refreshTokenInterceptor(apiClient, store);
apiClient.defaults.baseURL = joinPath([appConfig.apiBaseUrl]);

initCommonWebWidgetRepository();

export function App() {
  return (
    <BrowserRouter basename={appConfig.rootNavigationPath}>
      <MessageGlobalConfiguration />
      <Provider store={store}>
        <I18nConfigProvider
          theme={{
            token: themeTokens,
            components: themeComponentTokens,
          }}
        >
          <AntThemeProvider theme={theme}>
            <HelmetProvider>
              {/* Importazione GlobalStyle */}
              <ButtonTooltipsGlobalStyle />
              <LayoutGlobalStyle />
              <FontGlobalStyle />
              <ThemeGlobalStyle />
              <EngineThemeProvider accentColor={themeTokens.colorPrimary}>
                <QueryClientProvider client={queryClient}>
                  <ThemeRootProvider>
                    <BreadcrumbProvider>
                      <Routes />
                    </BreadcrumbProvider>
                  </ThemeRootProvider>
                </QueryClientProvider>
              </EngineThemeProvider>
            </HelmetProvider>
          </AntThemeProvider>
        </I18nConfigProvider>
      </Provider>
    </BrowserRouter>
  );
}

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
